import { createTrackingUtils } from "..";
import { UIOrder } from "@flights/types";

export const isFlightHasCiriumUpdatedDates = (order?: UIOrder) => {
  if (!order) {
    return false;
  }

  return order.airOrder.flightSegments.some((segment) => {
    return segment.legs.some((leg) => {
      return leg.updatedDepartureTime || leg.updatedArrivalTime;
    });
  });
};

// Tracking https://experiment.booking.com/experiments/flights_pb_updated_cirium_dates/2321290/stage1/main_report
export const trackFlightsPbUpdatedCiriumDates = createTrackingUtils({
  defaultStage: 1,
  name: "flights_pb_updated_cirium_dates",
  stages: {
    AFFECTED_USERS: 1
  },
  goals: {}
});
